// Copyright (c) Microsoft Corporation.
// Licensed under the MIT license.

import { combineReducers } from "redux";
import * as appSettings from "./applicationReducer";
import * as connections from "./connectionsReducer";
import * as currentProject from "./currentProjectReducer";
import * as recentProjects from "./recentProjectsReducer";
// import * as UploadedDocsList from "./uploadFilesReducers";
import * as loadBlobFiles from "./loadBlobFilesReducer";
import * as loadModelsReducer from "./loadModelsReducer";
import * as appError from "./appErrorReducer";
import * as appTitle from "./appTitleReducer";
import * as loggedInUser from "./authReducer";
import * as logOutReducer from "./logOutReducer";
import * as selectedOcrFiles from "./fileOcrReducer";
import * as operationsReducers from "./operationsReducers";
import * as filesUploadingReducer from "./filesUploadingReducer";
import * as loadTestFilesReducers from "./loadTestFilesReducers";
import * as loadOPTestFiles from "./loadOPTestFilesReducer";
import * as prebuiltSettings from "./prebuiltSettingsReducer";

/**
 * All application reducers
 * @member appSettings - Application Settings reducer
 * @member connections - Connections reducer
 * @member recentProjects - Recent Projects reducer
 * @member loadModelsReducer - Load Models reducer
 * @member loadBlobFiles - Load Files reducer
 * @member currentProject - Current Project reducer
 * @member appError = Application error
 */
export default combineReducers({
    appSettings: appSettings.reducer,
    connections: connections.reducer,
    recentProjects: recentProjects.reducer,
    currentProject: currentProject.reducer,
    loadModels: loadModelsReducer.reducer,
    userQueues: operationsReducers.reducer,
    loadAllFiles: loadBlobFiles.reducer,
    appError: appError.reducer,
    appTitle: appTitle.reducer,
    selectedOcrFiles: selectedOcrFiles.reducer,
    loggedInUser: loggedInUser.reducer,
    logOutUser: logOutReducer.reducer,
    loadTestFiles: loadTestFilesReducers.reducer,
    uploadFilesCount: filesUploadingReducer.reducer,
    loadOPTestFiles:loadOPTestFiles.reducer,
    prebuiltSettings: prebuiltSettings.reducer
});
